import { SerializedScheduledPost } from './types';

/**
 * What a post still accepts, in one place.
 *
 * The server refuses a write on a post that is out of our hands: `posted` and
 * `canceled` are final, and `publishing` means the worker holds the row and is
 * uploading it. A write on such a row answers 409 and changes nothing, so the
 * app hides the button and stops the call before it leaves.
 */

/** The post is out of the artist's hands: the worker is uploading it now. */
export function isPostPublishing(post: SerializedScheduledPost): boolean {
  return post.status === 'publishing';
}

/** Caption edits, a new hour and Cancel all need the same answer. */
export function isPostEditable(post: SerializedScheduledPost): boolean {
  return post.status !== 'posted' && post.status !== 'canceled' && post.status !== 'publishing';
}

/** "I posted it" only counts while the post is neither final nor mid-upload. */
export function canConfirmPostPosted(post: SerializedScheduledPost): boolean {
  return post.status !== 'posted' && post.status !== 'canceled' && post.status !== 'publishing';
}

/** The manual share sheet opens only while a post waits on the artist. */
export function canSharePost(post: SerializedScheduledPost): boolean {
  return post.status === 'awaitingManualPost';
}
